import Yup from '../validationsLib'

/**
 * Validations rules for login page
 */
export default Yup.object().shape({
    email: Yup.string()
        .email("Please enter a valid email address.")
        .required("Email cannot be blank!"),
    password: Yup.string()
        .required('Password cannot be blank!')
})
